import React, { memo, useState, Suspense, lazy } from "react";
import { Badge } from "@material-ui/core";
import { useSelector } from "react-redux";
import {
  selectPushNotifications,
  selectTotalNewNotifications,
} from "redux/notification/selectors";
import NotificationsIcon from "@material-ui/icons/Notifications";
import style from "./style.module.scss";

const PushNotification = lazy(() => import("components/PushNotification"));

const PushNotifications = () => {
  const pushNotifications = useSelector(selectPushNotifications);
  const notReadNotis = useSelector(selectTotalNewNotifications);
  const [notiAnchorEl, setNotiAnchorEl] = useState(null);
  return (
    <>
      <Badge
        badgeContent={notReadNotis}
        spanor="secondary"
        invisible={notReadNotis === 0}
        className={style.notificationIcon}
        classes={{ badge: style.customBadge }}
        max={20}
        onClick={(event) => setNotiAnchorEl(event.currentTarget)}
      >
        <NotificationsIcon
          classes={{ root: style.icon }}
          onClick={(event) => setNotiAnchorEl(event.currentTarget)}
        />
      </Badge>
      {notiAnchorEl && (
        <Suspense fallback={<></>}>
          <PushNotification
            notifications={pushNotifications}
            notiAnchorEl={notiAnchorEl}
            handleClosePushNoti={() => setNotiAnchorEl(null)}
          />
        </Suspense>
      )}
    </>
  );
};

export default memo(PushNotifications);
